export function Field({ label, hint, children }) {
    return (
        <div className="space-y-2">
            <label className="overline text-[#5C5C5C]">{label}</label>
            {children}
            {hint && <div className="font-body text-xs text-[#5C5C5C]">{hint}</div>}
        </div>
    );
}

export function TextInput({ value, onChange, placeholder, type = "text", testId, required, min, max }) {
    return (
        <input
            data-testid={testId}
            type={type}
            value={value ?? ""}
            onChange={(e) => onChange(type === "number" ? Number(e.target.value) : e.target.value)}
            placeholder={placeholder}
            required={required}
            min={min}
            max={max}
            className="imq-input"
        />
    );
}

export function TextArea({ value, onChange, placeholder, rows = 3, testId }) {
    return (
        <textarea
            data-testid={testId}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            rows={rows}
            className="imq-input"
        />
    );
}

export function Select({ value, onChange, options, testId, placeholder }) {
    return (
        <select
            data-testid={testId}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            className="imq-input"
        >
            <option value="">{placeholder || "Selecione..."}</option>
            {options.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
            ))}
        </select>
    );
}

export function Toggle({ checked, onChange, label, testId }) {
    return (
        <label data-testid={testId} className="flex items-center gap-3 cursor-pointer select-none">
            <span
                className={`relative w-10 h-6 rounded-full transition-colors ${checked ? "bg-[#1A1A1A]" : "bg-black/15"}`}
                onClick={() => onChange(!checked)}
            >
                <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${checked ? "translate-x-4" : ""}`} />
            </span>
            <span className="font-body text-sm">{label}</span>
        </label>
    );
}

export function Tag({ children, onRemove }) {
    return (
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#F8F8F5] border border-black/5 text-xs font-display">
            {children}
            {onRemove && (
                <button type="button" onClick={onRemove} className="text-[#5C5C5C] hover:text-red-600">×</button>
            )}
        </span>
    );
}
